import React from "react";
import { SimpleGrid } from "@chakra-ui/react";
import MissionCard from "./MissionCard";

interface MissionListProps {
    missions: any[];
    onPostuler: (missionId: string) => void;
}

const MissionList: React.FC<MissionListProps> = ({ missions, onPostuler }) => {
    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
            {missions.map((mission) => (
                <MissionCard
                    key={mission.id}
                    mission={mission}
                    onPostuler={onPostuler}
                />
            ))}
        </SimpleGrid>
    );
};

export default MissionList;